import React, { useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config';
import { showError } from '../utils/alerts';
import '../styles/components/Login.css';

const Login = ({ setToken }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${API_BASE_URL}/api/auth/login`, { email, password });
      setToken(response.data.token);
      console.log("Token recibido:", response.data.token);

    } catch (error) {
      console.error('Login error:', error);
      console.log("Detalles del error:", error.response?.data || error.message);

      // Manejar error de pago pendiente (403)
      if (error.response?.status === 403 && error.response?.data?.requierePago) {
        const { message, mesActual, añoActual } = error.response.data;

        const meses = [
          'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
          'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
        ];

        const mesNombre = meses[mesActual - 1];

        showError(
          `${message}\n\n` +
          `No tienes el pago de ${mesNombre} ${añoActual} registrado.\n\n` +
          `Contacta a ventas para regularizar tu situación.`
        );
      } else {
        showError(error.response?.data?.message || 'Error al iniciar sesión');
      }
    }
  };
  

  return (
    <div className="login-container">
      <div className="login-image"></div>
      <div className="login-form-container">
        <form onSubmit={handleSubmit} className="login-form">
        <h2><span class="taxi-highlight">TⒶXí</span> te lleva al futuro de la contabilidad</h2>
          <p>Ingresa a tu cuenta</p>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" required />
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" required />
          <button type="submit">Login</button>
      
          <a href="/forgot-password" className="forgot-password">Recuperar contraseña</a>
        </form>
      </div>
    </div>
  );
};

export default Login;
